import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import('./views/index.vue')
    },
    {
        path: '/case',
        name: 'case',
        component: () => import('./views/case.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('./views/about.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('./views/contact.vue')
    },
    {
        path: '/technology',
        name: 'technology',
        component: () => import('./views/technology.vue')
    },
    {
        path: '/CMS',
        name: 'CMS',
        component: () => import('./views/CMS.vue')
    },
    {
        path: '/CC',
        name: 'CC',
        component: () => import('./views/CC.vue')
    },
    {
        path: '/CTI',
        name: 'CTI',
        component: () => import('./views/CTI.vue')
    },
    {
        path: '/CTI/IVR',
        name: 'IVR',
        component: () => import('./views/IVR.vue')
    },
    {
        path: '/CTI/CATI',
        name: 'CATI',
        component: () => import('./views/CATI.vue')
    },
    {
        path: '/CTI/CTMS',
        name: 'CTMS',
        component: () => import('./views/CTMS.vue')
    },
    {
        path: '/CTI/FAX',
        name: 'FAX',
        component: () => import('./views/FAX.vue')
    },
    {
        path: '/CTI/HR',
        name: 'HR',
        component: () => import('./views/HR.vue')
    },
    {
        path: '/CTI/ISPEAK',
        name: 'ISPEAK',
        component: () => import('./views/ISPEAK.vue')
    },
    {
        path: '/CTI/MCRS',
        name: 'MCRS',
        component: () => import('./views/MCRS.vue')
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import('./views/privacy.vue')
    },
    {
        path: '/service',
        name: 'service',
        component: () => import('./views/service.vue')
    },
    {
        path: '/ISP',
        name: 'ISP',
        component: () => import('./views/ISP.vue')
    },
    {
        path: '/announcement',
        name: 'announcement',
        component: () => import('./views/announcement.vue')
    }
];
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }; // 換頁後捲動至頂
    }
});
export default router;
